import * as types from "../types";
import AuthService from "../../components/services/auth-service";
import LoanService from "../../components/services/loan-service";

export const header = {
  "content-type": "application/json",
  Accept: "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
}
export const userLogin = (userInfo) => async (dispatch) => {
  await dispatch({ type: types.LOGIN_BEGIN });
  try {
  const response:any = await AuthService.loginUser(userInfo)
  if (response?.data?.isSuccess === false) {
      dispatch({ type: types.LOGIN_FAILURE, message: response?.data?.message });
    } else {
      dispatch({ type: types.LOGIN_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    console.error("Login error: ", error);
    dispatch({ type: types.LOGIN_FAILURE, message: "An error occurred during login." });
  }
};

export const adminUserLogin = (userInfo) => async (dispatch) => {
  await dispatch({ type: types.LOGIN_BEGIN });
  try {
    const response = await AuthService.adminLogin(userInfo)
    if (response?.status === false) {
        dispatch({ type: types.LOGIN_FAILURE, message: response?.message });
      } else if(response?.isSuccess === true) {
        dispatch({ type: types.LOGIN_SUCCESS, payload: response });
      }
    } catch (error) {
      console.error("Login error: ", error);
      dispatch({ type: types.LOGIN_FAILURE, message: "An error occurred during login." });
    }
};

export const logout = () => ({
  type: types.LOGOUT,
});

export const userToken = (userInfo) => async (dispatch) => {
  await dispatch({ type: types.SEND_TOKEN_BEGIN });
  const response = await AuthService.userToken(userInfo)
  if(response?.data?.status === false){
    dispatch({ type: types.SEND_TOKEN_FAILURE, message: response?.data?.message })
  }
  else{
    dispatch({ type: types.SEND_TOKEN_SUCCESS, payload: response });
  }
};

export const reset = () => ({
  type: types.RESET,
});

export const reset_token = () => ({
  type: types.RESET_TOKEN,
});

export const getUserDetails = (userId: any) => async (dispatch) => {
  try {
    const details = await AuthService.userDetails(userId)
    await dispatch({ type: types.GET_USERDETAILS_BEGIN });
    dispatch({ type: types.GET_USERDETAILS_SUCCESS, payload: details.data });
    if(details?.data?.status===false){
      dispatch({ type: types.SEND_TOKEN_FAILURE, message: details?.data?.message })
    }
  } catch (error: any) {
    dispatch({ type: types.GET_USERDETAILS_FAILURE, message: error?.message });
  }
};

export const makeLoanRequest = (loanDetails: any) => async (dispatch) => {
  await dispatch({ type: types.LOAN_APPLY_BEGIN });
  try {
    const details: any = await LoanService.loanApplication(loanDetails);
    dispatch({ type: types.LOAN_APPLY_SUCCESS, payload: details });
  } catch (error: any) {
    dispatch({ type: types.LOAN_APPLY_FAILURE, message: error.message })
  }
};

export const resetLoanApplication = () => ({
  type: types.LOAN_APPLY_RESET,
});

export const adminToken = (userInfo) => async (dispatch) => {
  await dispatch({ type: types.SEND_TOKEN_BEGIN });
  const response = await AuthService.adminToken(userInfo)
  if(response?.data?.status === false){
    dispatch({ type: types.SEND_TOKEN_FAILURE, message: response?.data?.message })
  }
  else{
    dispatch({ type: types.SEND_TOKEN_SUCCESS, payload: response });
  }
};

// export const postFirstApproval = (userInfo: any) => async (dispatch) => {
//   try {
//     await dispatch({ type: types.POST_LOAN_STATUS_BEGIN });
//     // const signUp: any = await firstLoanApproval(userInfo);
//     const approve = await LoanService.approveLoans(userInfo)
//     console.log({approve})
//     dispatch({ type: types.POST_LOAN_STATUS_SUCCESS, payload: approve });
//   } catch (error: any) {
//     console.log({error})
//     dispatch({ type: types.POST_LOAN_STATUS_FAILURE, message: error.message });
//   }
// };

export const postFirstApproval = (userInfo: any) => async (dispatch) => {
  try {
    await dispatch({ type: types.POST_LOAN_STATUS_BEGIN });
    
    const approve = await LoanService.approveLoans(userInfo);

    dispatch({ type: types.POST_LOAN_STATUS_SUCCESS, payload: approve });
  } catch (error: any) {
    // const errorMessage = error?.message || error?.error || "Something went wrong";
    
    dispatch({ type: types.POST_LOAN_STATUS_FAILURE, payload: error });
  }
};


export const loanHistory = () => async (dispatch) => {
  await dispatch({ type: types.GET_LOAN_HISTORY_BEGIN });
  try {
    const response  = await LoanService.loanHistory()
    dispatch({ type: types.GET_LOAN_HISTORY_SUCCESS, payload: response.data });
  } catch (error: any) {
    // dispatch({ type: types.GET_LOAN_HISTORY_FAILURE, message: error.message });
    dispatch({ type: types.GET_LOAN_HISTORY_FAILURE, message: error.message });
  }
};

export const userLoanAcceptance = (loanRef) => async (dispatch) => {
  await dispatch({ type: types.SEND_LOAN_ACCEPTANCE_BEGIN });
  try {
    const theToken: any = await LoanService?.userLoanAcceptance(loanRef);
    dispatch({ type: types.SEND_LOAN_ACCEPTANCE_SUCCESS, payload: theToken });
  } catch (error: any) {
    dispatch({
      type: types.SEND_LOAN_ACCEPTANCE_FAILURE,
      message: error.message,
    });
  }
};

export const resetLoanAcceptance = () => ({
  type: types.SEND_LOAN_ACCEPTANCE_RESET,
});

export const resetAdminApproval = () => ({
  type: types.POST_LOAN_STATUS_RESET,
});




export const postSendOTP = (otpInfo: any) => async (dispatch) => {
  try {
    await dispatch({ type: types.SEND_OTP_BEGIN });
    const signUp: any = await LoanService.sendOTP(otpInfo);
    dispatch({ type: types.SEND_OTP_SUCCESS, payload: signUp });
  } catch (error: any) {
    dispatch({ type: types.SEND_OTP_FAILURE, message: error.message });
  }
};

export const resetSendOTP = () => ({
  type: types.SEND_OTP_RESET,
});

export const sendVendorDetails = (vendorInfo: any) => async (dispatch) => {
  await dispatch({ type: types.SEND_VENDOR_DETAILS_BEGIN });
  try {
    const signUp: any = await LoanService.sendVendorDetails(vendorInfo);
    dispatch({ type: types.SEND_VENDOR_DETAILS_SUCCESS, payload: signUp });
  } catch (error: any) {
    dispatch({ type: types.SEND_VENDOR_DETAILS_FAILURE, message: error.message });
  }
};

export const resetSendVendorDetails = () => ({
  type: types.SEND_VENDOR_DETAILS_RESET,
});
